import { Link, styled } from "@mui/material";
import { Delete } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { Layer, GeoJSON } from "leaflet";

import { deleteLayerStyle, basePolygonLayerStyle } from "config/geometryStyles";

interface Props {
  layer: Layer | GeoJSON;
  isDisabled: boolean;
  setIsEditing: (isEditing: boolean) => void;
  deleteGeoJSONLayer: () => void;
}

export function DeleteStudyArea(props: Props) {
  const { layer, isDisabled, deleteGeoJSONLayer, setIsEditing } = props;
  const { t } = useTranslation();
  function setHoverStyles() {
    //@ts-ignore
    layer.setStyle({
      ...deleteLayerStyle,
    });
  }

  function removeHoverStyles() {
    // @ts-ignore
    layer.bringToFront();
    //@ts-ignore
    layer.setStyle({
      ...basePolygonLayerStyle,
      color: "purple",
      fillColor: "transparent",
    });
  }

  function onDelete() {
    layer.remove();
    setIsEditing(false);
    deleteGeoJSONLayer();
  }

  return (
    <StyledDiv onMouseEnter={setHoverStyles} onMouseLeave={removeHoverStyles}>
      {isDisabled && (
        <>
          <Delete color="disabled" />
          <Link className="disabled">{t("label.deletePolygon")}</Link>
        </>
      )}
      {!isDisabled && (
        <>
          <Delete color="primary" />
          <Link onClick={onDelete}>{t("label.deletePolygon")}</Link>
        </>
      )}
    </StyledDiv>
  );
}

const StyledDiv = styled("div")`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
  .MuiLink-root {
    &.disabled {
      pointer-events: none;
      text-decoration: none;
      cursor: not-allowed;
      color: ${({ theme }) => theme.palette.grey[400]};
    }
  }
`;
